/* eslint-disable */
export const maxLifetime = 97

export default [
[ 0, 1000 ],
[ 1, 372 ],
[ 2, 288 ],
[ 3, 223 ],
[ 4, 173 ],
[ 5, 142 ],
[ 6, 117 ],
[ 7, 97 ],
[ 8, 80 ],
[ 9, 61 ],
[ 10, 38 ],
[ 11, 27 ],
[ 12, 23 ],
[ 13, 19 ],
[ 14, 15 ],
[ 15, 12 ],
[ 16, 10 ],
[ 17, 8 ],
[ 18, 6 ],
[ 19, 5 ],
[ 20, 4 ],
[ 21, 0 ]
]
